<div class="home-body">
  <div class="body-header home-body__content">
    <div class="home-body__header">{{ 'homeBody.header' | translate }}</div>
    <h1 class="heading-lg home-body__title">{{ 'homeBody.welcomeTitle' | translate }}</h1>
    <p class="form-md home-body__subtitle">{{ 'homeBody.subtitle' | translate }}</p>
    <button class="btn-primary home-body__button" (click)="goShopSettings()">
      {{ 'homeBody.addShopInfoButton' | translate }}
    </button>
    <button class="emphasis home-body__link" (click)="showOnboardingSlides()">
      {{ 'homeBody.viewOnboardingSlides' | translate }}
    </button>
  </div>
</div>
